module.exports = __webpack_public_path__ + "img/weibo.c18a1ff8.png";